import { defineMessages } from 'react-intl';

export default defineMessages({
    mailingAddress: {
        id: 'agency.admin.views.messages.mailingAddress1',
        defaultMessage: 'Mailing Address: '
    },
    primaryContact: {
        id: 'agency.admin.views.messages.primaryContact1',
        defaultMessage: 'Primary Contact: '
    },
    status: {
        id: 'agency.admin.views.messages.status',
        defaultMessage: 'Status: '
    },
    eftPayment: {
        id: 'agency.admin.views.messages.eftPayment',
        defaultMessage: 'EFT Payments: '
    },
    orgTitle: {
        id: 'agency.admin.views.messages.orgTitle',
        defaultMessage: 'Agency/Location: '
    },
    producerCode: {
        id: 'agency.admin.views.messages.producerCode',
        defaultMessage: 'Producer Code: '
    }
});